import {
	ApplicationLogo,
	ClientLogo,
	Footer,
	Header,
	IMenuItem,
	ImpersonateDropdown,
	InfoBar,
	ISideNavCategory,
	IUserMenuOptions,
	MainContent,
	MessageHelper,
	ModalPopup,
	Toast,
	UserMenu,
} from '@aon/aon-tws-common-ui';
import surveyBuilderLogo from '@aon/aon-tws-common-ui/build/lib/assets/images/logo-surveyBuilder.svg';
import { Permission, PermissionUtil } from '@aon/aon-tws-common-ui/build/lib/components/Permission';
import { UserSessionManager } from '@aon/aon-tws-common-ui/build/lib/components/Session/UserSessionManager';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import * as React from 'react';
import { User } from 'oidc-client';
import styled from 'styled-components';
import Constants from '../../constants';
import { ClientContextContainer } from '../../containers/ClientContext/ClientContextSwitch';
import ContentConstants from '../../contentConstants';
import { ILayoutActionCreators } from '../../models';
import PermissionConstants from '../../permissionConstants';
import { INotificationState } from '../../store/NotificationStore';
import userManager from '../../userManager';

const InfoBarRightContainer = styled.div`
	margin-left: auto;
	display: inline-flex;
`;
InfoBarRightContainer.displayName = 'InfoBarRightContainer';

const InfoBarDivider = styled.div`
	width: 1px;
	border-left: ${globalVars.borderThin} ${globalVars.borderSolid} ${globalVars.secondaryGray2};
	height: 40px;
	margin: 0 15px;
	@media (min-width: 0) and (max-width: 768px) {
		height: 32px;
	}
`;
InfoBarDivider.displayName = 'InfoBarDivider';

export interface ILayoutProps {
	user?: User;
	sideNavMenuItems?: ISideNavCategory[];
	loggedInUserMenuOptions?: IUserMenuOptions[];
	notifications: INotificationState;
	headerMenuItems: IMenuItem[];
}

export type LayoutProps = ILayoutProps & ILayoutActionCreators;

export class Layout extends React.Component<React.PropsWithChildren<LayoutProps>> {
	constructor(props: LayoutProps) {
		super(props);

		this.getUserMenu = this.getUserMenu.bind(this);
	}

	public render() {
		const impersonatorName = this.props.user && this.props.user.profile.impersonator_name;

		const userHasAccessToApp = PermissionUtil.GetUserApplications().indexOf(PermissionConstants.ApplicationName) > -1;
		const isInternal = this.props.user && this.props.user.profile.package === Constants.PACKAGE_INTERNAL;

		return (
			<div>
				<UserSessionManager
					sessionKeyPrefix='SB'
					clientLogoutUrl={Constants.API_CLIENT_LOGOUT_URL}
					identityServerUrl={Constants.IDENTITY_SERVER_URL}
					landingPageRoute={Constants.ADMINPORTAL_URL + Constants.ROUTE_LANDING}
					timeoutInSeconds={Constants.SESSION_TIMEOUT}
					userManager={userManager}
				/>
				{impersonatorName && (
					<ImpersonateDropdown
						impersonatorName={impersonatorName}
						identityServerUrl={Constants.IDENTITY_SERVER_URL}
						userManager={userManager}
					/>
				)}
				<Header menuModel={this.props.headerMenuItems} displayHeaderNavigation={true} environment={Constants.BRANCH_ENVIRONMENT} />
				<InfoBar>
					<ApplicationLogo mobileLogoSrc={surveyBuilderLogo} logoSrc={surveyBuilderLogo} showSideNavMenu={false} />
					<ClientLogo />
					{userHasAccessToApp && (
						<ClientContextContainer
							identityServerUrl={Constants.IDENTITY_SERVER_URL}
							userManagementBaseUrl={Constants.USER_MANAGEMENT_API_URL}
							userManager={userManager}
						/>
					)}
					<InfoBarRightContainer>{this.getUserMenu()}</InfoBarRightContainer>
				</InfoBar>
				<MainContent>
					<Permission {...PermissionConstants.SURVEYBUILDER_ALL}>{this.props.children}</Permission>
					{this.props.notifications?.instance !== undefined && (
						<Toast key={this.props.notifications.key} {...this.props.notifications.instance} />
					)}

					{!userHasAccessToApp && !impersonatorName && (
						<ModalPopup
							isOpen={true}
							stayOpen={true}
							title={ContentConstants.NO_ACCESS_MODAL_TITLE}
							primaryButtonText={ContentConstants.BUTTONS_LOGOUT}
							secondaryButtonText={undefined}
							contenthcentered={true}
							contentvcentered={true}
							contentfullwidth={true}
							onClosed={() => {
								/** */
							}}
							onSubmit={() => this.props.logout(userManager, Constants.IDENTITY_SERVER_URL)}
							type={'lightbox'}
						>
							<div>{MessageHelper.getFormattedErrorMessages(ContentConstants.NO_ACCESS_MODAL_MESSAGE)}</div>
						</ModalPopup>
					)}
				</MainContent>
				<Footer
					isInternal={isInternal}
					isLlc={Constants.IS_LLC}
					releaseVersion={Constants.APP_RELEASE_NUMBER}
					domainName={Constants.DOMAIN_NAME}
				/>
			</div>
		);
	}

	public getUserMenu() {
		if (this.props.user) {
			return <UserMenu userName={this.props.user.profile.name} href={'#'} userMenuOptions={this.props.loggedInUserMenuOptions} />;
		}
	}
}
